export const loadingSelector = (state) => state.webCards.loading;
export const errorsSelector = (state) => state.webCards.errors;
export const dataListSelector = (state) => state.webCards.ids.map((id) => (
  { ...state.webCards.data[id], id }
));
export const dataSelector = (state) => (id) => state.webCards.data[id];
export const dataIdsLengthSelector = (state) => state.webCards.ids.length;
